import { render, staticRenderFns } from "./RootView.vue?vue&type=template&id=61f63e48&scoped=true"
import script from "./RootView.vue?vue&type=script&lang=js"
export * from "./RootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f63e48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61f63e48')) {
      api.createRecord('61f63e48', component.options)
    } else {
      api.reload('61f63e48', component.options)
    }
    module.hot.accept("./RootView.vue?vue&type=template&id=61f63e48&scoped=true", function () {
      api.rerender('61f63e48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/minfo/RootView.vue"
export default component.exports